import { createPermission } from '@backstage/plugin-permission-common';

export const dxPortalAdvancedFeaturesPermission = createPermission({
  name: 'dxportal.features.advanced',
  attributes: {},
});

export const dxPortalBasicFeaturesPermission = createPermission({
  name: 'dxportal.features.basic',
  attributes: {},
});
